import * as moment from "moment";
import { translate } from "./translate";
import * as TranslationsKeys from "./locale/translationsKeys";
import { dialogConfirmationButtonClassName, dialogCancelButtonClassName } from "./dialogConstants";
import { debounce } from 'lodash';

// taken from https://stackoverflow.com/a/32800728/379279
export function isNullOrWhitespace(input : string | undefined) : boolean {
    return !input || !input.trim();
}

export function isGuid(guid: string): boolean {
    const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i; // taken from https://stackoverflow.com/a/13653180/379279
    return pattern.test(guid);
}

export function htmlEncode(html: string): string {
    return $("<div/>").text(html).html();
}

// taken from https://stackoverflow.com/a/44195856/379279 and slightly modified (removed support for &amp; &lt; &gt; )
export function decodeEntitiesForHtmlSanitizer(encodedString : string) : string {
    var translateRegex = /&(nbsp|quot);/g;
    var translate = {
        "nbsp": "\u00A0",
        "quot": "\""
    };
    return encodedString.replace(translateRegex, (match, entity) => translate[entity]).replace(/&#(\d+);/gi, (match, numStr) => {
        var num = parseInt(numStr, 10);
        return String.fromCharCode(num);
    });
}

export function attachCancelButtonConfirmation(
    cancelButtonId = "cancel",
    message = translate(TranslationsKeys.Global_CancelEditing_Message)
) {
    $(`#${cancelButtonId}`).on("click", () => {
        bootbox.confirm({
            message: message,
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                history.back();
            }
        });
    });
}


function isSerializedDate(value) {
    // Dates are serialized in TZ format, examples: '1981-12-20T04:00:14.000Z', '2020-10-13T13:05:45.673504Z'
    const datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+Z$/;

    return typeof value === "string" && datePattern.test(value);
}
function dateReviver(key, value) {
    if (isSerializedDate(value)) {
        return moment(value);
    }

    return value;
}

export function parseJsonWithDateSupport(jsonData: string) {
    return JSON.parse(jsonData, dateReviver);
}

export const jQueryAjaxConverters = {
    "text json": parseJsonWithDateSupport
};

export function parseJson<TModel>(json): TModel {
    return JSON.parse(json);
}

export function setJsonValue(element: JQuery<HTMLElement>, objectToJson) {
    element.val(JSON.stringify(objectToJson));
}

// taken from https://stackoverflow.com/a/4673436/379279
export function stringFormat(format: string, ...args) {
    return format.replace(/{(\d+)}/g, (match, number) => typeof args[number] != "undefined"
        ? args[number]
        : match);
}

// taken from https://stackoverflow.com/a/37511463/379279
export function removeDiacritics(text: string): string {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

// Allows child element filtering for a parent element via text input.
export function applyChildElementsFilter(
    filterInput: HTMLInputElement,
    parentElement: HTMLElement,
    childElementSelector: string
) {
    const applyFilter = () => {
        const searchString = removeDiacritics(filterInput.value).toLowerCase();
        parentElement.querySelectorAll(childElementSelector)
            .forEach(el => {
                const elText = removeDiacritics(el.textContent || '').toLowerCase();
                (el as HTMLElement).hidden = elText.indexOf(searchString) === -1;
        });
    };

    filterInput.addEventListener('keyup', debounce(applyFilter, 200));
}

// replaceAll string function is supported in latest Firefox and Chrome, but not in nodejs, and without this function Jest tests are failing
export function replaceAll(text: string, pattern: string, replaceValue: string) {
    return text.replace(new RegExp(pattern, "gi"), replaceValue);
}

// taken from https://stackoverflow.com/a/1349426/379279
export function generateRandomAlphaNumericString(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}

export function safeRemoveChild(targetElement: HTMLElement, child: HTMLElement) {
    for (var i = 0; i < targetElement.children.length; i++) {
        if (targetElement.children[i] === child) {
            targetElement.removeChild(child);
            break;
        }
    }
}

export function splitWithoutEmptyStrings(text: string, separator: string) : string[] {
    return text.split(separator).filter(x => x !== "");
}